import { ImageSize } from './types'

export function imageSizeProperties({
    bodyHeightIn, 
    headerHeightPx,
     heightPx,
     widthPx,
     widthIn
}: {
    widthPx: number
    heightPx: number
    bodyHeightIn: number
    headerHeightPx: number
    widthIn?: number
}): ImageSize {
    //INFO: calc variables: inx = size inche, hx = size px, h1 = body px,  , in1 = body in
    //inx  = (hx * in1)/h1

    const footerHeightIn = 1/2
    const contentPx = heightPx - headerHeightPx
    const contentIn = bodyHeightIn + 1

    const headerHeightIn = (headerHeightPx * contentIn) / contentPx
    const bodyHeightPx = (bodyHeightIn * contentPx) / contentIn
    const footerHeightPx = (footerHeightIn * contentPx) / contentIn

    const widthInFinal = widthIn ? widthIn : (widthPx * bodyHeightIn) / bodyHeightPx

    return {
        header: {
            px: {
                height: headerHeightPx,
                width: widthPx,
                x: 0,
                y: 0
            },
            in: {
                height: headerHeightIn,
                width: widthInFinal,
                x: 0,
                y: 0
            }
        },
        body: {
            px: {
                height: bodyHeightPx,
                width: widthPx,
                y: headerHeightPx,
                x: 0
            },
            in: {
                height: bodyHeightIn,
                width: widthInFinal,
                y: headerHeightIn,
                x: 0
            }
        },
        footer: {
            px: {
                height: footerHeightPx,
                width: widthPx,
                y: headerHeightPx + bodyHeightPx,
                x: 0
            },
            in: {
                height: footerHeightIn,
                width: widthIn,
                y: headerHeightIn + bodyHeightIn,
                x: 0
            }
        }
    }
}
